<template>
  <BaseModal
    :value="true"
    @input="$emit('close')"
    title="Phone"
    id="infoauto-create-phone"
  >
    <div class="flex flex-col p-4">
      <h1 class="txt-lg font-bold mb-4">
        Add Phone to customer "{{ customerName }}"
      </h1>
      <form
        @submit.prevent="submit"
        class="flex flex-col gap-2"
        v-if="!loading"
      >
        <input
          v-model.trim="areaCode"
          :placeholder="$t('create_infoauto_customer_modal.area_code')"
          :maxlength="areaCodeMaxLength"
          class="regular full bordered"
        />
        <input
          v-model="phone"
          label="Phone"
          placeholder="Enter phone"
          required
          class="regular full bordered"
        />
        <select v-model.number="phoneType" class="regular full bordered">
          <option
            v-for="type in phoneTypes"
            :key="type.value"
            :value="type.value"
            >{{ type.label }}</option
          >
        </select>
        <button type="submit" class="btn-dark-button w-40 mt-6">Save</button>
      </form>
      <div v-else>
        <BaseSmallSpinner />
      </div>
    </div>
  </BaseModal>
</template>
<script>
import { addPhoneToCustomer } from "@/api/store/Infoauto.js";
import {
  PHONE_TYPES,
  DEFAULT_PHONE_TYPE,
  AREA_CODE_MAX_LENGTH,
  defaultAreaCode
} from "@/constants/infoautoPersona";
export default {
  props: {
    customerName: {
      type: String,
      required: true
    },
    customerInfoautoId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      areaCode: defaultAreaCode(
        this.$store.getters["general/getActiveStore"]?.code
      ),
      areaCodeMaxLength: AREA_CODE_MAX_LENGTH,
      phone: "",
      phoneType: DEFAULT_PHONE_TYPE,
      phoneTypes: PHONE_TYPES,
      loading: false
    };
  },
  methods: {
    submit() {
      if (this.phone === "") {
        return;
      }
      this.loading = true;
      addPhoneToCustomer(
        this.customerInfoautoId,
        this.phone,
        this.phoneType,
        this.areaCode
      )
        .then(data => {
          console.log("Phone created", data.phone);
          this.$emit(
            "phoneCreated",
            `${data.phone.codArea}${data.phone.numero}`,
            {
              areaCode: data.phone.codArea || "",
              number: data.phone.numero,
              infoautoPhoneId: data.phone.telefonoId || ""
            }
          );
        })
        .catch(error => {
          console.error("Error creating phone", error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
#infoauto-create-phone {
  .modal-content {
    width: 100%;
    max-width: 600px;
    height: auto;
  }
}
</style>
